// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7d8a52f1","977":"cf1c0760"}[chunkId] + ".chunk.js";
};